import { Paper, Box, Typography, Link } from "@mui/material";
import { useRTL } from "hooks/isRTL";

const ContentCard = ({ title, content }) => {
  const { t, isRTL } = useRTL();

  return (
    <Paper
      elevation={2}
      sx={{
        padding: "1.5rem",
        minWidth: "300px",
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        backgroundColor: "background.white",
        color: "background.dark",
      }}
    >
      {/* Card Title */}
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{
          marginBottom: "1rem",
          fontSize: "1.2rem",
        }}
      >
        {title}
      </Typography>

      <Box>
        {content.map(({ label, value }, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid #e0e0e0",
              paddingTop: "1rem",
              gap: "1rem",
              minWidth: 0,
            }}
          >
            {/* Label */}
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{
                flex: "0 0 180px",
                whiteSpace: "nowrap",
                textAlign: isRTL ? "right" : "left",
              }}
            >
              {label}
            </Typography>

            {/* Value */}
            {label === t("coordinates") ? (
              <Box
                sx={{
                  flex: "1 1 auto",
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                <Link
                  href={value}
                  target="_blank"
                  rel="noopener"
                  sx={{
                    color: "primary.main",
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                    display: "block",
                  }}
                >
                  {t("viewLocation")}
                </Link>
              </Box>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  flex: "1 1 auto",
                  color: "text.secondary",
                  textAlign: isRTL ? "right" : "left",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  minWidth: 0,
                }}
              >
                {label === t("phoneNumber") ||
                label === t("contactPhoneNumber") ? (
                  <span style={{ direction: "ltr", unicodeBidi: "embed" }}>
                    {value}
                  </span>
                ) : (
                  value
                )}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default ContentCard;
